import { IImageLayerProps, ILayerProps } from '@/version-types';
import './image-operate.less';
import { getFlipStyle, getImageTransformInfo, getInnerStyle } from '@/layers/image-layer/utils/layer';
import ImageScaleAction from './image-scale-action';
import MoveAction from './move-action';
import RotateAction from './rotate-action';

const ImageOperate: React.FC<{
    layer: ILayerProps;
    scale: number;
}> = ({ layer, scale }) => {
    const {
        maskURL,
        imageTransform: { flipH, flipV, scale: imageScale, rotate },
    } = layer.data as IImageLayerProps;
    const { originImgWidth, originImgHeight, offsetX, offsetY } = getImageTransformInfo(layer);
    const flipStyle = getFlipStyle(flipH, flipV);
    const imageInnerStyle = getInnerStyle(
        originImgWidth * scale * imageScale,
        originImgHeight * scale * imageScale,
        offsetX * scale,
        offsetY * scale,
        rotate,
        1,
        maskURL,
        layer.width * scale,
        layer.height * scale,
    );

    imageInnerStyle.transform = `translate(${offsetX * scale + ((layer.width - originImgWidth * imageScale) * scale) / 2}px, ${offsetY * scale + ((layer.height - originImgHeight * imageScale) * scale) / 2}px) rotate(${rotate}deg) scale(1)`;

    return (
        <div className="c-crop-image-operate">
            <div style={flipStyle}>
                <div style={{ ...imageInnerStyle }}>
                    <div className="img-gray-mask"></div>

                    <MoveAction
                        width={originImgWidth * scale * imageScale}
                        height={originImgHeight * scale * imageScale}
                    />

                    <ImageScaleAction rotate={layer.rotate} />
                    <RotateAction rotate={layer.rotate} scale={scale} />
                </div>
            </div>
        </div>
    );
};

export default ImageOperate;
